import { render, staticRenderFns } from "./PaySettingsTabs.vue?vue&type=template&id=4e45bbf0&scoped=true"
import script from "./PaySettingsTabs.vue?vue&type=script&lang=js"
export * from "./PaySettingsTabs.vue?vue&type=script&lang=js"
import style0 from "./PaySettingsTabs.vue?vue&type=style&index=0&id=4e45bbf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e45bbf0",
  null
  
)

export default component.exports